import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/currency/selected.png'
import _imports_1 from '@/assets/currency/unselected.png'
import _imports_2 from '@/assets/paper/success.png'
import _imports_3 from '@/assets/paper/error.png'


const _withScopeId = n => (_pushScopeId("data-v-163dba8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "dvCompile",
  class: "dv-title"
}, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_6 = { class: "dv-options" }
const _hoisted_7 = { class: "dv-option-answer dv-option-mt2" }
const _hoisted_8 = { class: "dv-options-img" }
const _hoisted_9 = {
  key: 0,
  class: "dv-option-img",
  src: _imports_0
}
const _hoisted_10 = {
  key: 1,
  class: "dv-option-img",
  src: _imports_1
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dv-options-topic" }, "对", -1))
const _hoisted_12 = {
  key: 0,
  class: "dv-answer"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "dv-answer"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "dv-option-answer dv-option-mt47" }
const _hoisted_19 = { class: "dv-options-img" }
const _hoisted_20 = {
  key: 0,
  class: "dv-option-img",
  src: _imports_0
}
const _hoisted_21 = {
  key: 1,
  class: "dv-option-img",
  src: _imports_1
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dv-options-topic" }, "错", -1))
const _hoisted_23 = {
  key: 0,
  class: "dv-answer"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "dv-answer"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "question-analysis"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analysis-title" }, "解析:", -1))
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.questionData.indexInQuestion !== undefined
            ? _ctx.questionData.indexInQuestion + "."
            : "") + _toDisplayString(_ctx.questionData.titleNum > 0 ? _ctx.questionData.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " (" + _toDisplayString(_ctx.questionData.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "dv-option",
          style: _normalizeStyle({
            borderColor: _ctx.currentAnswer === 1 ? '#1ac36e' : '#e3e3e3',
          }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleAnswer(1)))
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.currentAnswer === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : (_openBlock(), _createElementBlock("img", _hoisted_10))
          ]),
          _hoisted_11
        ], 4),
        (_ctx.props.disabled && 1 === _ctx.correctOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true),
        (
            _ctx.props.disabled &&
            _ctx.currentAnswer !== _ctx.correctOption &&
            1 === _ctx.currentAnswer
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", {
          class: "dv-option",
          style: _normalizeStyle({
            borderColor: _ctx.currentAnswer === 0 ? '#1ac36e' : '#e3e3e3',
          }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAnswer(0)))
        }, [
          _createElementVNode("div", _hoisted_19, [
            (_ctx.currentAnswer === 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : (_openBlock(), _createElementBlock("img", _hoisted_21))
          ]),
          _hoisted_22
        ], 4),
        (_ctx.props.disabled && 0 === _ctx.correctOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        (
            _ctx.props.disabled &&
            _ctx.currentAnswer !== _ctx.correctOption &&
            0 === _ctx.currentAnswer
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", {
            class: "analysis-content",
            innerHTML: _ctx.props?.question?.analysis || ''
          }, null, 8, _hoisted_31)
        ]))
      : _createCommentVNode("", true)
  ]))
}